{
  "name": "scheuch-frontend",
  "version": "1.2.0",
  "scripts": {
    "build:dev": "npm run pre-build && ng build --configuration dev",
    "build:qa": "npm run pre-build && ng build --configuration qa",
    "build:prod": "npm run pre-build && ng build --configuration prod",
    "serve": "npm run icons-generate && ng serve --host 0.0.0.0 --port=4207 -o --ssl --ssl-key ./cert/localhost-key.pem --ssl-cert ./cert/localhost.pem",
    "deploy:dev": "azcopy copy \"./dist/scheuch-frontend/*\" \"$AZURE_DEPLOY_URL_DEV\" --recursive=true",
    "deploy:qa": "azcopy copy \"./dist/scheuch-frontend/*\" \"$AZURE_DEPLOY_URL_QA\" --recursive=true",
    "deploy:prod": "azcopy copy \"./dist/scheuch-frontend/*\" \"$AZURE_DEPLOY_URL_PROD\" --recursive=true",
    "prettier": "npx prettier --write '**/*.(html|ts|js|scss)'",
    "release": "standard-version",
    "release-major": "standard-version --release-as major",
    "release-minor": "standard-version --release-as minor",
    "release-patch": "standard-version --release-as patch",
    "lint": "eslint src/app",
    "test": "ng test",
    "test:ci": "ng test --watch=false --code-coverage --browsers=ChromeHeadlessCI",
    "test:coverage": "ng test --code-coverage --watch=false",
    "pre-build": "npm run icons-generate",
    "icons": "npm run icons-minify && npm run icons-generate",
    "icons-minify": "find src/assets/icons -name *.svg -type f -exec svgo {} --config svgo.js \\;",
    "icons-generate": "svg-to-ts-constants",
    "api-generate": "rm -rf ./src/app/shared/api && openapi-generator-cli generate && npm run prettier",
    "loco:status": "loco-cli status",
    "loco:push": "loco-cli push -y",
    "loco:pull": "loco-cli pull",
    "loco:sync": "npm run loco:push && npm run loco:pull && npm run prettier",
    "prepare": "husky"
  },
  "lint-staged": {
    "src/**/*.ts": "eslint",
    "src/**/*.html": "eslint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.7",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.7",
    "@angular/compiler": "^21.0.7",
    "@angular/core": "^21.0.7",
    "@angular/forms": "^21.0.7",
    "@angular/material": "^21.0.5",
    "@angular/platform-browser": "^21.0.7",
    "@angular/platform-browser-dynamic": "^21.0.7",
    "@angular/router": "^21.0.7",
    "@azure/msal-angular": "^5.0.4",
    "@azure/msal-browser": "^5.2.0",
    "@microsoft/applicationinsights-web": "^3.0.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.32.1",
    "angular-resizable-element": "^8.0.1",
    "date-fns": "^4.1.0",
    "lodash-es": "^4.17.21",
    "papaparse": "^5.4.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/schematics": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@angular/build": "^21.0.5",
    "@angular/cli": "^21.0.5",
    "@angular/compiler-cli": "^21.0.7",
    "@eslint/eslintrc": "^3.1.0",
    "@eslint/js": "^9.14.0",
    "@netural/eslint-config-angular": "^4.0.3",
    "@openapitools/openapi-generator-cli": "^2.27.0",
    "@tailwindcss/forms": "^0.5.3",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/jasmine": "^6.0.0",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "^24.10.13",
    "@types/papaparse": "^5.3.7",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "eslint": "^9.28.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "husky": "^9.1.7",
    "jasmine-core": "^6.0.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^16.3.2",
    "loco-cli": "^3.2.0",
    "postcss": "^8.4.21",
    "prettier": "^3.0.2",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "standard-version": "^9.5.0",
    "style-dictionary": "^5.1.3",
    "svg-to-ts": "^12.0.0",
    "svgo": "^4.0.0",
    "tailwindcss": "^4.1.12",
    "typescript": "~5.9.3"
  }
}
